// Style constants
export const BREAK_POINT_SCREEN_XS = 480;
export const BREAK_POINT_SCREEN_SM = 768;
export const BREAK_POINT_SCREEN_MD = 979;
export const BREAK_POINT_SCREEN_LG = 1200;
export const SCROLL_HEIGHT_TO_STYCKY_CAMPAIGN_INFORMATIONS = 220;
export const TOP_OF_ARTICLE_IMAGE_WITH_RECO = 502;
export const SCROLL_HEIGHT_TO_SHOW_BACKTOTOP = 300;
export const TRANSITION_TIME = 1000;
export const TRANSITION_TIME_SCROLL_TOP = TRANSITION_TIME;
export const TRANSITION_TIME_SCROLL_TOP_ARTICLE_DETAILS = 400;
export const TRANSITION_TIME_DEFAULT = 0.3;
export const COLOR_WHITE = '#ffffff';
export const COLOR_EXTRA_LIGHT = '#f7f7f7';
export const COLOR_LIGHT = '#ededed';
export const COLOR_LIGHT_MEDIUM = '#cccccc';
export const COLOR_GREY = '#aeaeae';
export const COLOR_MEDIUM = '#898989';
export const COLOR_DARK = '#4f4f4f';
export const COLOR_GREEN = '#87bf47';
export const COLOR_EXTRA_DARK = '#353535';
export const COLOR_YELLOW = '#eda821';
export const COLOR_RED = '#a9182a';
export const COLOR_TEXT = '#353535';

/* eslint-disable no-multi-spaces */
export const GERMANY        = 17;
export const FRANCE         = 18;
export const NETHERLANDS    = 35;
export const BELGIUM        = 36;
export const BELGIUM_FR     = 37;
export const COM_DOMAIN     = 38;
export const AUSTRIA        = 39;
export const SWITZERLAND    = 40;
export const SWITZERLAND_FR = 41;
export const UNITED_KINGDOM = 43;
export const ITALY          = 44;
export const POLAND         = 45;
export const SPAIN          = 46;
export const CZECH          = 51;
/* eslint-enable no-multi-spaces */

// app domain mapping lounge vs fashion store
export const APP_DOMAIN_SHOP = {
    [GERMANY]: 1,
    [FRANCE]: 11,
    [NETHERLANDS]: 5,
    [BELGIUM]: 25,
    [BELGIUM_FR]: 26,
    [COM_DOMAIN]: 28, // no com domain in shop, now set for FI: SE 27, FI 28
    [AUSTRIA]: 19,
    [SWITZERLAND]: 20,
    [SWITZERLAND_FR]: 21,
    [UNITED_KINGDOM]: 16,
    [ITALY]: 15,
    [POLAND]: 24,
};

export const COUNTRIES = {
    GERMANY,
    FRANCE,
    NETHERLANDS,
    BELGIUM,
    BELGIUM_FR,
    COM_DOMAIN,
    AUSTRIA,
    SWITZERLAND,
    SWITZERLAND_FR,
    UNITED_KINGDOM,
    ITALY,
    POLAND,
    SPAIN,
    CZECH,
};

export const COUNTRY_CODE_FI = 'FI';
export const COUNTRY_CODE_SE = 'SE';
export const COUNTRY_CODE_DK = 'DK';

export const COUNTRY_CODES = {
    GERMANY: 'DE',
    FRANCE: 'FR',
    NETHERLANDS: 'NL',
    BELGIUM: 'BL',
    DENMARK: 'DK',
    AUSTRIA: 'AT',
    SWEDEN: 'SE',
    FINLAND: 'FI',
    SWITZERLAND: 'CH',
    UNITED_KINGDOM: 'GB',
    ITALY: 'IT',
    POLAND: 'PL'
};

export const EVENT_ENTITY_TYPE = 'event';
export const LINK_ENTITY_TYPE = 'link';
export const UPCOMING_CAMPAIGNS = 'upcoming';
export const SHORT_DELIVERY = 'delivery_promise_148'; // the category tag for short delivery

export const TOPS = 'tops';
export const DRESSES = 'dresses';
export const PANTS = 'pants';
export const UNDERWEAR = 'underwear';
export const SHOES = 'shoes';
export const SHIRTS = 'shirts';
export const ACCESSORIES = 'accessories';
export const BEDCLOTHES = 'bedclothes';
export const OTHER_SIZES = 'other';

export const SIZES_ORDER = [
    TOPS,
    DRESSES,
    PANTS,
    UNDERWEAR,
    SHOES,
    SHIRTS,
    ACCESSORIES,
    BEDCLOTHES,
    OTHER_SIZES
];

export const MYFILTER_SIZE_CATEGORIES = [
    TOPS,
    DRESSES,
    PANTS,
    UNDERWEAR,
    SHOES
];

export const FILTER_COLOR_WHITE = '0';
export const FILTER_COLOR_BEIGE = '50';
export const FILTER_COLOR_GRAY = '100';
export const FILTER_COLOR_SILVER = '150';
export const FILTER_COLOR_YELLOW = '200';
export const FILTER_COLOR_GOLD = '250';
export const FILTER_COLOR_RED = '300';
export const FILTER_COLOR_ORANGE = '350';
export const FILTER_COLOR_PURPLE = '400';
export const FILTER_COLOR_PINK = '450';
export const FILTER_COLOR_BLUE = '500';
export const FILTER_COLOR_TURQUOISE = '550';
export const FILTER_COLOR_GREEN = '600';
export const FILTER_COLOR_OLIVE = '650';
export const FILTER_COLOR_BROWN = '700';
export const FILTER_COLOR_WAVE = '750';
export const FILTER_COLOR_BLACK = '800';
export const FILTER_COLOR_SPECIAL = '900';
export const FILTER_COLOR_MULTI = '950';

export const FILTER_COLORS = [
    FILTER_COLOR_WHITE,
    FILTER_COLOR_BEIGE,
    FILTER_COLOR_GRAY,
    FILTER_COLOR_SILVER,
    FILTER_COLOR_YELLOW,
    FILTER_COLOR_GOLD,
    FILTER_COLOR_RED,
    FILTER_COLOR_ORANGE,
    FILTER_COLOR_PURPLE,
    FILTER_COLOR_PINK,
    FILTER_COLOR_BLUE,
    FILTER_COLOR_TURQUOISE,
    FILTER_COLOR_GREEN,
    FILTER_COLOR_OLIVE,
    FILTER_COLOR_BROWN,
    FILTER_COLOR_WAVE,
    FILTER_COLOR_BLACK,
    FILTER_COLOR_SPECIAL,
    FILTER_COLOR_MULTI,
];

export const CATEGORY_LEVEL_OTHER_THAN_GENDER = 3;

export const MULTICOLOR = '950';

export const EMPTY_TRANSLATION = '<empty/>';

export const ARTICLE_STATUS_RESERVED = 'RESERVED';
export const ARTICLE_STATUS_SOLD_OUT = 'SOLD_OUT';
export const ARTICLE_STATUS_AVAILABLE = 'AVAILABLE';

export const SHOW_FLASH_MESSAGE_TIME = 2000;

export const CART_EXPIRE_IN_5_MINUTES = '5_MINUTES';
export const CART_EXPIRE_IN_SHORT_PERIOD = 'SHORT_PERIOD';
export const CART_EXPIRED = 'EXPIRED';
export const CART_STATUS_ERROR_CODE = 409;
export const ADD_CART_MAX_SIMPLES_PER_CONFIG = 501;
export const ADD_CART_MAX_30_SIMPLES_IN_CART = 510;
export const ADD_CART_MAX_SIMPLES_PER_CONFIG_REACHED_QTY_ADJUSTED = 502;
export const ADD_CART_STOCK_NOT_FOUND = 503;
export const ADD_CART_MAX_AVAILABLE_STOCK_REACHED_QTY_ADJUSTED = 504;
export const ADD_CART_NOT_COMBINABLE_ADD_ITEM_NOT_COMBINABLE = 505;
export const ADD_CART_SIZE_SELECTION_WARNING = 506;
export const ADD_CART_VOUCHER_DISABLED = 507;
export const ADD_CART_NOT_COMBINABLE_NOT_COMBINABLE_IN_CART = 508;
export const ADD_CART_SIZE_SELECTION_ERROR = 509;

export const FLASH_MESSAGE_TYPE_SUCCESS = 'success';
export const FLASH_MESSAGE_TYPE_ERROR = 'error';
export const FLASH_MESSAGE_TYPE_WARNING = 'warning';

export const ARTICLE_PRICE = 'price';
export const ARTICLE_SPECIAL_PRICE = 'specialPrice';
export const ARTICLE_BASE_PRICE = 'basePrice';

export const ARTICLE_PRICE_SUPERSCRIPT = '1';
export const ARTICLE_PRICE_SUPERSCRIPT_RRP = '*';
export const ARTICLE_PRICE_SUPERSCRIPT_EXCHANGE_RATE = '4';

export const ARTICLES_SORT_ATTRACTIVITY = 'attractivity';
export const ARTICLES_SORT_AVAILABILITY = 'availability';
export const ARTICLES_SORT_PRICE_ASC = 'price_asc';
export const ARTICLES_SORT_PRICE_DESC = 'price_desc';
export const ARTICLES_SORT_SAVINGS = 'savings';

export const ARTICLE_VIDEO_ID = 'article-video';

export const ARTICLE_MEDIA_TYPE_IMAGE = 'IMAGE';
export const ARITCLE_MEDIA_TYPE_VIDEO = 'VIDEO_LOW';

export const FILTER_TAB_NONE = 'SHOW_NONE';
export const FILTER_TAB_CATEGORIES = 'SHOW_CATEGORIES';
export const FILTER_TAB_SIZE = 'SHOW_SIZE';
export const FILTER_TAB_BRAND = 'SHOW_BRAND';
export const FILTER_TAB_COLOR = 'SHOW_COLOUR';
export const FILTER_TAB_MATERIAL = 'SHOW_MATERIAL';
export const FILTER_TAB_PRICE = 'SHOW_PRICE';
export const FILTER_TAB_SORT = 'SHOW_SORT';
export const FILTER_TAB_ALL = 'SHOW_ALL';

export const MALE_CAMPAIGN = 'MALE';
export const FEMALE_CAMPAIGN = 'FEMALE';
export const UNISEX_CAMPAIGN = 'UNISEX';

export const MALE_CAMPAIGN_PHOENIX = 'male';
export const FEMALE_CAMPAIGN_PHOENIX = 'female';
export const UNISEX_CAMPAIGN_PHOENIX = 'unisex';

export const ERROR_MYLOUNGE_UNKNOWN_TAB = 'ERROR_MYLOUNGE_UNKNOWN_TAB';

export const ENTER_KEY_CODE = 13;

export const CURRENCY_EURO = 'EUR';
export const ONE_SIZE = 'onesize';

export const STORAGE_FILTERS = 'filters';
export const STORAGE_SORT = 'sort';

export const TRACK_ROUTE_CHANGE_EVENT = 'TRACK_ROUTE_CHANGE_EVENT';
export const FALLBACK_ROUTE = '/event';
export const MYLOUNGE_ROUTE = '/event';
export const CATALOG_ROUTE = '/campaigns';

export const TRACK_DATA = 'TRACK_DATA';
export const TRACK_RECO_NO_RECO = 0;
export const TRACK_RECO_COLLABORATIVE = 1;
export const TRACK_RECO_TOPSELLER = 2;
export const TRACK_RECO_CAMPAIGN_OVERVIEW = 3;

export const TRACK_SIZE_RECO_NO_RECO = 'No recommendation';

export const TRACK_ADD_TO_CART_SOURCE = {
    PDP: 'PDP',
    QUICK_VIEW: 'quick view',
};

export const TRACK_TRAFFIC_SOURCES = [
    'notification'
];

export const ARTICLE_DETAILS_IMAGE_ASPECT_RATIO = 1.44;
export const MOBILE_HEADER_HEIGHT = 91;
export const MOBILE_ARTICLE_DETAILS_IMAGE_TOP_SPACE = 10;
export const MOBILE_ARTICLE_DETAILS_IMAGE_BOTTOM_SPACE = 60;
export const MOBILE_ARTICLE_DETAILS_IMAGE_MIN_HEIGHT = 408;

export const DESKTOP_HEADER_HEIGHT = 75;
export const DESKTOP_ARTICLE_DETAILS_IMAGE_TOP_SPACE = 37;
export const DESKTOP_ARTICLE_DETAILS_IMAGE_MIN_HEIGHT = 490;
export const DESKTOP_ARTICLE_DETAILS_IMAGE_MIN_WIDTH = 340;
export const DESKTOP_ARTICLE_DETAILS_IMAGE_BOTTOM_SPACE = 20;
export const DESKTOP_ARTICLE_DETAILS_INFORMATION_WIDTH = 340;
export const DESKTOP_ARTICLE_DETAILS_THUMBNAILS_WIDTH = 45;
export const DESKTOP_ARTICLE_DETAILS_THUMBNAILS_HEIGHT = 70;
export const DESKTOP_ARTICLE_DETAILS_THUMBNAILS_OPACITY_ACTIVE = 0.3;
export const DESKTOP_ARTICLE_DETAILS_THUMBNAILS_OPACITY_DEFAULT = 1;
export const DESKTOP_ARTICLE_DETAILS_THUMBNAILS_ARROW_TOP_BOTTOM_POSITION = '-37px';
export const DESKTOP_ARTICLE_DETAILS_HORIZONTAL_MARGIN = 40;

export const PAGE_MYLOUNGE = 'PAGE_MYLOUNGE';
export const PAGE_CATALOG = 'PAGE_CATALOG';
export const PAGE_PDP = 'PAGE_PDP';
export const PAGE_UPCOMING = 'PAGE_UPCOMING';
export const PAGE_HELP = 'PAGE_HELP';
export const PAGE_SUCCESS = 'PAGE_SUCCESS';

export const ARTICLE_DETAIL_DETAILS = 'details';
export const ARTICLE_DETAIL_MEASURES = 'measures';
export const ARTICLE_DETAIL_MATERIAL = 'material';
export const ARTICLE_DETAIL_CARE = 'care';
export const ARTICLE_DETAIL_WARRANTY = 'warranty';
export const ARTICLE_DETAIL_TECH_DETAILS = 'tech_details';
export const ARTICLE_DETAIL_SCOPE_OF_DELIVERY = 'scope_of_delivery';
export const ARTICLE_DETAIL_AWARD = 'award';
export const ARTICLE_DETAIL_RETURN = 'return';
export const ARTICLE_DETAIL_DELIVERY = 'delivery';

export const ARTICLE_DETAILS_HEADLINES = {
    [ARTICLE_DETAIL_DETAILS]: 'headlineDetails',
    [ARTICLE_DETAIL_MATERIAL]: 'headlineMaterial',
    [ARTICLE_DETAIL_MEASURES]: 'headlineMeasures',
    [ARTICLE_DETAIL_CARE]: 'headlineCare',
    [ARTICLE_DETAIL_WARRANTY]: 'headlineWarranty',
    [ARTICLE_DETAIL_TECH_DETAILS]: 'headlineTechDetails',
    [ARTICLE_DETAIL_SCOPE_OF_DELIVERY]: 'headlineScopeOfDelivery',
    [ARTICLE_DETAIL_AWARD]: 'headlineAward',
    [ARTICLE_DETAIL_RETURN]: 'headlineReturn',
    [ARTICLE_DETAIL_DELIVERY]: 'headlineDelivery'
};

export const ARTICLE_DETAIL_AMOUNT_OF_SHOWN_SIZES = 11;
export const ARTICLE_DETAIL_AMOUNT_OF_SHOWN_PLACES = ARTICLE_DETAIL_AMOUNT_OF_SHOWN_SIZES + 1;
export const ARTICLE_DETAIL_AMOUNT_OF_SHOWN_SIZES_IN_ROW = 4;
export const ARTICLE_DETAIL_AMOUNT_OF_SHOWN_IMAGES = 7;
export const MIN_HEIGHT_TO_CHANGE_IMAGE_HEIGHT = 100;

export const ARTICLE_DETAIL_RECOMMENDATION_HEIGHT = 390;

export const DEFAULT_SIZEHELPER_URL = '/sizehelper';

export const HELP_PAGE = '/help';

export const TWENTY_FOUR_HOURS_IN_MILLISECONDS = 24 * 60 * 60 * 1000;

export const CANCELLED_REQUEST = 'CANCELLED_REQUEST';

export const SIZE_RECO = {
    TOO_SMALL_ARTICLE: 'TOO_SMALL_ARTICLE',
    TOO_LARGE_ARTICLE: 'TOO_LARGE_ARTICLE',
    STANDARD_RECOMMENDATION: 'STANDARD_RECOMMENDATION',
    NO_RECOMMENDATION: 'NO_RECOMMENDATION',
};

// mobile hashes for sub-routing
export const HEADER_MY_ACCOUNT_MENU_HASH = '#mobileMyAccount';
export const HEADER_MY_ACCOUNT_OVERVIEW_MENU_HASH = '#mobileMyAccountOverview';
export const HEADER_MY_ACCOUNT_MENU_SUPPORT_HASH = '#mobileMyAccountSupport';
export const HEADER_CART_MENU_HASH = '#mobileCart';
export const CATALOG_FILTER_TABS_HASH = '#filterTabs';
export const CATALOG_FILTER_ACTIVE_TAB_HASH = '#filterActiveTab';
export const CATALOG_FILTER_CATEGORIES_HASH = '#filterCategories';

export const NON_APPLICABLE = 'N/A';
export const ARTICLE_MIN_VIEW_PERCENTAGE = 0.5;
export const ARTICLE_MIN_VIEW_AVERAGE = 240;


export const CAMPAIGN_GONE_RESPONSE_STATUS = 410;

export const ERROR_INVALID_CATEGORIES = 'ERROR_INVALID_CATEGORIES';
export const ERROR_WRONG_CAMPAIGNID = 'wrong campaignId';

export const WEBVIEWS_ROUTE_HOME = 'zlounge://home';
export const SPECIAL_COUPON_ERROR_HEADER = 'SPECIAL_COUPON_ERROR_HEADER';

// abtesting
export const OCTUPUS_MODE_ACTIVE = 'TEST';
export const TRACK_ABTESTING = 'TRACK_ABTESTING';

// last chance
export const LASTCHANCE_TAB_ID_DACH = 280;
export const LASTCHANCE_TAB_FR_BEFR_CHFR = 282;
export const LASTCHANCE_TAB_NL_BENL = 284;
export const LASTCHANCE_TAB_COM_UK = 286;
export const LASTCHANCE_TAB_IT = 288;
export const LASTCHANCE_TAB_PL = 290;
export const LASTCHANCE_TAB_ES = 1000;
export const LASTCHANCE_TAB_CZ = 1001; // TODO Make it for CZ

export const APPDOMAIN_TO_TAB_ID_MAP = {
    [GERMANY]: LASTCHANCE_TAB_ID_DACH,
    [FRANCE]: LASTCHANCE_TAB_FR_BEFR_CHFR,
    [NETHERLANDS]: LASTCHANCE_TAB_NL_BENL,
    [BELGIUM]: LASTCHANCE_TAB_NL_BENL,
    [BELGIUM_FR]: LASTCHANCE_TAB_FR_BEFR_CHFR,
    [COM_DOMAIN]: LASTCHANCE_TAB_COM_UK,
    [AUSTRIA]: LASTCHANCE_TAB_ID_DACH,
    [SWITZERLAND]: LASTCHANCE_TAB_ID_DACH,
    [SWITZERLAND_FR]: LASTCHANCE_TAB_FR_BEFR_CHFR,
    [UNITED_KINGDOM]: LASTCHANCE_TAB_COM_UK,
    [ITALY]: LASTCHANCE_TAB_IT,
    [POLAND]: LASTCHANCE_TAB_PL,
    [SPAIN]: LASTCHANCE_TAB_ES,
    [CZECH]: LASTCHANCE_TAB_CZ,
};

export const TAB_FEMALE = 'gender_132';
export const TAB_MALE = 'gender_134';

export const UP = 'UP';
export const DOWN = 'DOWN';

export const SEC_SUB_SUCCESS_PLACEMENT = 'SUCCESS_PLACEMENT';
export const SEC_SUB_CLOSED_COOKIE = 'zl_secsub_closed';
export const MATERIAL_FILTER_COOKIE = 'zl_material_filter';

export const RECO_ITEM_WIDTH = 220;

export const CART_NAV_BUBBLE_TARGET_ELEMENT_ID = 'header-cart';

// Config Feature Keys
export const CONFIG_FEATURE_SIZE_RECO = 'size_reco';
export const CONFIG_FEATURE_SIZE_CHAT = 'size_chat';
export const CONFIG_FEATURE_SIZE_CHAT_BUTTON = 'size_chat_button';

// xmas special
export const XMAS_EVENT_DELIVERY_PROMISE = 'event_delivery_promise_christmas';
export const HIDE_DELIVERY_PROMISE_DIALOG_KEY = 'hideCECDeliveryMessage';
export const XMAS_BANNER_LOCATION = {
    isCatalog: 'catalog',
    isMylounge: 'mylounge',
    isArticleDetail: 'articleDetail'
};
